import { TrackEventName as EventName, TrackEvent as Event } from '../event';

const observeRegisterEvent = () => {
  // bz注册页面进入
  Event.safeOn(EventName.BZ_PAGE_VIEW, (data = {}) => {
    const val = {
      ...data,
      type: 'register',
      event: EventName.BZ_PAGE_VIEW,
    };
    Event.emit(EventName.SENSORS_TRACK, val);
  });

  // bz点击注册按钮
  Event.safeOn(EventName.BZ_REGISTER_PAGE_EXPOSE, (data = {}) => {
    const val = {
      ...data,
      type: 'register',
      event: EventName.BZ_REGISTER_PAGE_EXPOSE,
    };
    Event.emit(EventName.SENSORS_TRACK, val);
  });

  // 注册成功事件
  Event.safeOn(EventName.BZ_REGISTER_SUCCESS, (data = {}) => {
    const val = {
      ...data,
      type: 'register',
      event: EventName.BZ_REGISTER_SUCCESS,
    };
    Event.emit(EventName.SENSORS_TRACK, val);
  });
};

export default observeRegisterEvent;
